export default __webpack_public_path__ + "static/media/FAQPageLocation.a6897cf5.webp";